var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "v-toolbar",
        {
          staticClass: "report_bar",
          attrs: { flat: "", dense: "", color: "blue-grey lighten-5" }
        },
        [
          _c("v-toolbar-title", [
            _vm._v("\n      Total: $" + _vm._s(_vm.totalSales) + "\n          ")
          ]),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _vm.isToday &&
          ((_vm.currentDateSales && _vm.currentDateSales.length == 0) ||
            !_vm.currentDateSales)
            ? _c(
                "v-btn",
                {
                  staticClass: "blue--text",
                  attrs: { icon: "", color: "accent-2" },
                  on: {
                    click: function($event) {
                      return _vm.openlogSales()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("mdi-clipboard-edit-outline")])],
                1
              )
            : _vm.currentDateSales
            ? _c(
                "v-btn",
                {
                  staticClass: "blue--text",
                  attrs: { icon: "" },
                  on: {
                    click: function($event) {
                      return _vm.editSalesReport(_vm.currentDateSales)
                    }
                  }
                },
                [_c("v-icon", [_vm._v("mdi-clipboard-edit")])],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("allTransactionsByDate")
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12", md: "6" } },
            [
              _c("br"),
              _vm._v(" "),
              _c("p", [
                _vm._v("Prepaid "),
                _vm.calculatedDailySales
                  ? _c("span", { staticClass: "float-right" }, [
                      _vm._v(
                        "$ " +
                          _vm._s(_vm.calculatedDailySales.prepaidSales || 0)
                      )
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("hr", { staticClass: "spacer" }),
              _vm._v(" "),
              _c("v-subheader", [_vm._v("Credit Card")]),
              _vm._v(" "),
              _vm.calculatedDailySales && _vm.dailySalesReport
                ? _c("v-data-table", {
                    staticClass: "no-footer-table",
                    attrs: { headers: _vm.ccHeaders, items: _vm.ccItems },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "item.ccSales",
                          fn: function(ref) {
                            var item = ref.item
                            return [
                              _c("span", [
                                _vm._v("$ " + _vm._s(item.ccSales || 0) + " ")
                              ])
                            ]
                          }
                        },
                        {
                          key: "item.ccTerminal",
                          fn: function(ref) {
                            var item = ref.item
                            return [
                              _c("span", [
                                _vm._v(
                                  "$ " + _vm._s(item.ccTerminal || 0) + " "
                                )
                              ])
                            ]
                          }
                        },
                        {
                          key: "item.ccDiscrepancy",
                          fn: function(ref) {
                            var item = ref.item
                            return [
                              _c("span", [
                                _vm._v(
                                  "$ " + _vm._s(item.ccDiscrepancy || 0) + " "
                                )
                              ])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3477403520
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.currentDateSales
                ? _c("p", { staticClass: "reason" }, [
                    _vm._v(_vm._s(_vm.currentDateSales.ccNotes))
                  ])
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            { attrs: { cols: "12", md: "6" } },
            [
              _c("v-subheader", [_vm._v("Cash")]),
              _vm._v(" "),
              _vm.calculatedDailySales && _vm.dailySalesReport
                ? _c("v-data-table", {
                    staticClass: "no-footer-table",
                    attrs: { headers: _vm.cashHeaders, items: _vm.cashItems },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "item.cashSales",
                          fn: function(ref) {
                            var item = ref.item
                            return [
                              _c("span", [
                                _vm._v("$ " + _vm._s(item.cashSales || 0) + " ")
                              ])
                            ]
                          }
                        },
                        {
                          key: "item.Start",
                          fn: function(ref) {
                            var item = ref.item
                            return [
                              _c("span", [
                                _vm._v("$ " + _vm._s(item.Start || 0) + " ")
                              ])
                            ]
                          }
                        },
                        {
                          key: "item.total",
                          fn: function(ref) {
                            var item = ref.item
                            return [
                              _c("strong", [
                                _vm._v("$ " + _vm._s(item.total || 0) + " ")
                              ])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      1514630943
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-data-table",
                {
                  staticClass: "no-footer-table",
                  attrs: {
                    headers: _vm.onHandHeaders,
                    items: _vm.onHandItems,
                    "hide-default-header": "",
                    "mobile-breakpoint": 0
                  }
                },
                [
                  _c("template", { slot: "body.append" }, [
                    _c("tr", { staticClass: "blue--text" }, [
                      _c("th", [_vm._v("$1")]),
                      _vm._v(" "),
                      _c("th", [_vm._v("$5")]),
                      _vm._v(" "),
                      _c("th", [_vm._v("$10")]),
                      _vm._v(" "),
                      _c("th", [_vm._v("$20")]),
                      _vm._v(" "),
                      _c("th", [_vm._v("$50")]),
                      _vm._v(" "),
                      _c("th", [_vm._v("$100")])
                    ])
                  ])
                ],
                2
              ),
              _vm._v(" "),
              _c("v-data-table", {
                staticClass: "no-footer-table",
                attrs: { headers: _vm.cashOutHeaders, items: _vm.cashOutItems },
                scopedSlots: _vm._u([
                  {
                    key: "item.deposited",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _c("span", [
                          _vm._v("$ " + _vm._s(item.deposited || 0) + " ")
                        ])
                      ]
                    }
                  },
                  {
                    key: "item.cashTomoStart",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _c("span", [
                          _vm._v("$ " + _vm._s(item.cashTomoStart || 0) + " ")
                        ])
                      ]
                    }
                  },
                  {
                    key: "item.onHand",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _c("strong", [
                          _vm._v("$ " + _vm._s(item.onHand || 0) + " ")
                        ])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("ul", { staticClass: "cash" }, [
                _c("li", [
                  _vm._v("Discrepancy "),
                  _c("span", [_vm._v("$ " + _vm._s(this.cashDiscrepancy || 0))])
                ]),
                _vm._v(" "),
                _vm.currentDateSales
                  ? _c("li", [_vm._v(_vm._s(_vm.currentDateSales.cashNotes))])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _vm.checkGate("users-mgmt")
                ? _c("ul", { staticClass: "cash" }, [
                    _c("li", [
                      _vm._v("Safe "),
                      _vm.safe
                        ? _c("span", [
                            _vm._v("$ " + _vm._s(_vm.safe.totalInSafe))
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c(
                      "li",
                      [
                        _vm.safe
                          ? _c("span", [
                              _vm._v(
                                "\n        Last time banked\n        " +
                                  _vm._s(
                                    new Date(
                                      this.safe.lastTimeBanked
                                    ).toLocaleString("en-AU", {
                                      timeZone: "UTC",
                                      weekday: "short",
                                      year: "numeric",
                                      month: "short",
                                      day: "numeric"
                                    })
                                  ) +
                                  "\n      "
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            staticClass: "blue--text",
                            attrs: {
                              color: "accent-2",
                              disabled:
                                (_vm.currentDateSales &&
                                  _vm.currentDateSales.length == 0) ||
                                !_vm.currentDateSales
                            },
                            on: {
                              click: function($event) {
                                return _vm.bankTotalInSafe(_vm.currentDateSales)
                              }
                            }
                          },
                          [
                            _c("v-icon", [_vm._v("mdi-safe")]),
                            _vm._v(" Bank\n")
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }